import React from 'react';

const PRAYER_ACCENT = { shacharit: '#1e3a5f', mincha: '#92400e', maariv: '#312e81' };

const StatusBox = ({ msg, isError }) => (
  <div style={{
    width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
    direction: 'rtl', fontSize: '1rem', color: isError ? '#c0392b' : '#94a3b8',
  }}>
    {msg}
  </div>
);

const Countdown = ({ nextMinyan, secondsLeft, upcomingPrayers, allPrayerTimes, title, showTitle, bgColor, loading, error }) => {
  if (loading) return <StatusBox msg="טוען..." />;
  if (error)   return <StatusBox msg={error} isError />;
  if (!nextMinyan) return <StatusBox msg="אין מנינים שנותרו להיום" />;

  const accent = nextMinyan.color || PRAYER_ACCENT[nextMinyan.prayer] || '#0369a1';
  const isNow  = secondsLeft < 0;
  const hours  = Math.floor(secondsLeft / 3600);
  const mins   = Math.floor((secondsLeft % 3600) / 60);
  const secs   = secondsLeft % 60;

  let bigDisplay;
  let unitLabel;

  if (isNow) {
    bigDisplay = (
      <div style={{ ...bigNumStyle, color: accent, fontSize: 'clamp(3rem, 10vw, 6rem)', letterSpacing: '-0.02em' }}>
        עכשיו
      </div>
    );
    unitLabel = null;
  } else if (secondsLeft < 60) {
    bigDisplay = <div style={bigNumStyle}>{secondsLeft}</div>;
    unitLabel = 'שניות';
  } else if (secondsLeft < 3600) {
    bigDisplay = (
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '2px', direction: 'ltr' }}>
        <div style={bigNumStyle}>{String(mins).padStart(2, '0')}</div>
        <div style={colonStyle}>:</div>
        <div style={bigNumStyle}>{String(secs).padStart(2, '0')}</div>
      </div>
    );
    unitLabel = 'דקות : שניות';
  } else {
    bigDisplay = (
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '2px', direction: 'ltr' }}>
        <div style={bigNumStyle}>{String(hours).padStart(2, '0')}</div>
        <div style={colonStyle}>:</div>
        <div style={bigNumStyle}>{String(mins).padStart(2, '0')}</div>
      </div>
    );
    unitLabel = 'שעות : דקות';
  }

  return (
    <div style={{
      width: '100%', height: '100%', display: 'flex', flexDirection: 'column',
      direction: 'rtl', fontFamily: 'inherit', boxSizing: 'border-box',
      backgroundColor: bgColor || 'transparent', position: 'relative',
    }}>
      {showTitle && (
        <div style={{
          padding: '0.65rem 1rem', flexShrink: 0, borderBottom: '1px solid #e2e8f0',
        }}>
          <span style={{ fontWeight: 700, fontSize: '0.9rem', color: '#1e293b' }}>{title}</span>
        </div>
      )}

      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '1rem', gap: 0,
      }}>
        {!isNow && (
          <div style={{ fontSize: '0.85rem', color: '#94a3b8', fontWeight: 600, marginBottom: '0.5rem' }}>
            המניין הבא בעוד
          </div>
        )}

        {bigDisplay}

        {unitLabel && (
          <div style={{ fontSize: '1rem', color: '#64748b', fontWeight: 600, marginTop: '0.25rem' }}>
            {unitLabel}
          </div>
        )}

        {/* Prayer name + time */}
        <div style={{
          marginTop: '1.25rem',
          display: 'flex', alignItems: 'center', gap: '0.6rem',
          backgroundColor: accent + '12',
          borderRadius: 100,
          padding: '0.4rem 1.25rem',
        }}>
          <span style={{ fontSize: '1.3rem', fontWeight: 800, color: accent }}>
            {nextMinyan.label}
          </span>
          <span style={{ width: 4, height: 4, borderRadius: '50%', backgroundColor: accent + '60', flexShrink: 0 }} />
          <span style={{
            fontSize: '1.3rem', fontWeight: 800, color: '#0f172a',
            fontVariantNumeric: 'tabular-nums', direction: 'ltr',
          }}>
            {nextMinyan.time}
          </span>
        </div>
      </div>
    </div>
  );
};

const bigNumStyle = {
  fontSize: 'clamp(4rem, 12vw, 8rem)',
  fontWeight: 900,
  color: '#0f172a',
  lineHeight: 1,
  letterSpacing: '-0.05em',
  fontVariantNumeric: 'tabular-nums',
};

const colonStyle = {
  fontSize: 'clamp(3rem, 10vw, 6rem)',
  fontWeight: 900,
  color: '#94a3b8',
  lineHeight: 1,
  paddingBottom: '0.1em',
};

export default Countdown;
